import {Schema} from 'platform/components';

import {Nullish, TestIdProps} from 'shared/web';

import {ColOrColGroupDef} from '../utils/transformDefinition';
import {ActionCallback} from './ActionCallback';
import {ActionDefinitionObject} from './ActionDefinition';
import {ColDef} from './AgGridTypes';
import {GetDataQueryResponse, TransformedDefinitionApiResponse, VirtualPreset} from './Api';
import {DataGridProps} from './DataGridProps';
import {LoadingCellRenderer} from './LoadingCellRenderer';
import {TranslationMap} from './TranslationMap';

export type AgGridWrapperProps = {
  filterSchema?: Schema;
  autoGroupColumnDef?: ColDef;
  translationMap?: TranslationMap;
  loadingCellRenderer?: LoadingCellRenderer;
  onPageChangeCallback?: (page: number) => void;
  definition: TransformedDefinitionApiResponse;
  columnConfig: ColOrColGroupDef[];
  actionsDefinition: ActionDefinitionObject;
  dataQuery: GetDataQueryResponse;
  setVirtualPreset: (virtualPreset: VirtualPreset | Nullish) => void;
  predefinedColumns: readonly string[];
  actionCallback?: ActionCallback;
} & Pick<
  DataGridProps,
  | 'gridCode'
  | 'presetInstanceId'
  | 'emptyState'
  | 'onRowSelectionChange'
  | 'externalFilterId'
  | 'autoHeight'
  | 'queryModifier'
  | 'onFilterChanged'
  | 'initialSmartSearch'
> &
  TestIdProps;
